import {VolmaMapWithSelectDTO} from "./VolmaMapWithSelectDTO"

export default VolmaMapWithSelectDTO;